require('waypoints/lib/noframework.waypoints')

export const MyAccordians = {
  name: 'my-accordians',
  template: `
    <div class="o-accordian">
      <div class="o-accordian__wrapper">
        <div class="o-accordian__menu" tabindex="0">
          <div class="o-accordian__item" v-for="(tab, index) in tabs" :class="{'o-accordian__item--active': currentIndex === index}" @click="changeTab(index)">
            <div class="o-accordian__item__inner">{{ tab.title }}</div>
          </div>
        </div>
      </div>
      <div class="o-accordian__content">
        <slot></slot>
      </div>
    </div>
  `,
  props: {
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      tabs: [],
      currentIndex: 0
    }
  },
  methods: {
    addTab (tab) {
      this.tabs.push(tab)
      let index = this.tabs.indexOf(tab)
      if (index === this.currentIndex) {
        this.current = tab
        this.tabs[this.currentIndex].active = true
      }
    },
    changeTab (index) {
      this.currentIndex = index
      this.setActiveTab()
    },
    setActiveTab () {
      for (let value of this.tabs) {
        value.active = value === this.tabs[this.currentIndex]
      }
      Waypoint.refreshAll()
      this.$emit('tab-changed')
    }
  },
  created () {
    this.currentIndex = this.initialIndex
    setTimeout(() => {
      this.$emit('tab-changed')
    }, 0)
  }
}

export const MyAccordian = {
  name: 'my-accordians',
  template: `
    <div v-if="active"><slot></slot></div>
  `,
  data () {
    return {
      active: false
    }
  },
  props: {
    title: {
      required: true,
      type: String
    },
    isActive: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  created () {
    this.active = this.isActive
    this.$parent.addTab(this)
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-accordian.js